import FormGroupInput from "./Inputs/formGroupInput.vue";

import Button from "./Button";

import Card from "./Cards/Card.vue";
import StatsCard from "@/components/patrimoine/StatsCard.vue";
import SidebarPlugin from "./SidebarPlugin/index";

let components = {
  FormGroupInput,
  Card,
  SidebarPlugin,
};

export default components;

export {
  FormGroupInput,
  Card,
  StatsCard,
  Button,
  SidebarPlugin,
};
